import { Box, Button, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import { trackEvent } from "utils/tracking";

import HomeCard from "../../components/HomeCard";
import { Icon } from "./shared/icons";
import { Callout, Pill } from "./shared/primitives";
import { buttonSx, g } from "./shared/tokens";

interface Props {
  completed?: boolean;
}

const AddNicheFollowupCard = ({ completed }: Props) => {
  const navigate = useNavigate();

  return (
    <HomeCard
      icon={completed ? <Icon.Check size={20} /> : <Icon.Send size={20} />}
      iconSx={{
        background: completed ? g.green100 : g.primaryTint,
        color: completed ? g.successText : g.primary,
      }}
      title="Add a followup to your niche"
      subtitle="Boost reply rates by adding a follow-up template to a niche"
      chip={
        completed ? (
          <Pill variant="default" icon={<Icon.Check size={12} />}>
            Completed
          </Pill>
        ) : (
          <Pill variant="yellow" icon={<Icon.Sparkle size={12} />}>
            Recommended
          </Pill>
        )
      }
    >
      <Callout tone="yellow" icon={<Icon.Sparkle size={16} />}>
        <strong>Why a follow-up?</strong> Most replies come from a second touch.
        Adding a follow-up to a niche's email setting gives your outreach a
        second chance to land — without any extra work from you.
      </Callout>

      <Box sx={{ mt: "18px" }}>
        {completed ? (
          <Typography sx={{ fontSize: 14, color: g.text2 }}>
            <Box
              component="span"
              sx={{
                color: g.successText,
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                mr: "8px",
                fontWeight: 600,
              }}
            >
              <Icon.Check size={14} /> Follow-up added!
            </Box>
            Visit your{" "}
            <Link
              sx={{ fontWeight: 600, textDecoration: "none" }}
              href={`/${routes.virtualAssistant}`}
            >
              VA Settings
            </Link>{" "}
            to manage niches.
          </Typography>
        ) : (
          <Button
            fullWidth
            sx={{ ...buttonSx.base, ...buttonSx.primary }}
            onClick={() => {
              trackEvent("Gamification - Add Niche Followup");
              navigate(`/${routes.virtualAssistant}`);
            }}
          >
            Add a follow-up <Icon.ArrowRight size={14} />
          </Button>
        )}
      </Box>
    </HomeCard>
  );
};

export default AddNicheFollowupCard;
